import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function CompanySuggestionCards({ summary, activeCompanyId, onReview }) {
  if (!summary.length) return null;
  return (
    <>
      <Typography variant="caption" color="text.secondary">
        Sugestões de agrupamento por empresa (só junta pacotes da mesma empresa):
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(auto-fill, minmax(240px, 1fr))" }, gap: 1, my: 1 }}>
        {summary.map((item) => (
          <Paper
            key={item.companyId}
            variant="outlined"
            sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 0.5, borderColor: String(item.companyId) === activeCompanyId ? "primary.main" : "divider" }}
          >
            <b>{item.name}</b>
            {item.candidateGroups > 0 ? (
              <>
                <Typography variant="body2" color="secondary">
                  ⧉ {item.candidateGroups} {item.candidateGroups > 1 ? "sugestões" : "sugestão"} · {item.candidatePackages} pacotes podem virar {item.candidateGroups}
                </Typography>
                <Button size="small" variant="outlined" sx={{ alignSelf: "flex-start" }} onClick={() => onReview(item.companyId)}>
                  Revisar sugestões desta empresa
                </Button>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">Nada para juntar</Typography>
            )}
          </Paper>
        ))}
      </Box>
    </>
  );
}
